exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button-wraper[data-v-1f821c80] {\n  margin: 40px 0 20px;\n}\n.button-wraper a[data-v-1f821c80] {\n  margin: 0;\n}", ""]);

// exports
